let ArraySettingFunc = null;
let SetRefresh = null;
let data = []

const InitToastManager = (func, setRefresh) => {
    ArraySettingFunc = func;
    SetRefresh = setRefresh;
}

const RemoveToastNotification = (index) => {
    data.splice(index, 1);
    ArraySettingFunc(data);
    SetRefresh(data + index + "_" + data.length)
}

const AddToastNotification = (text, type) => {

    const oldData = data.find(x => x.text == text && x.type == type);

    if(!oldData) {
        data.push({text: text, type: type});
    }
    
    ArraySettingFunc(data);
    SetRefresh(data + "_" + text + "_" + data.length)
}

export {InitToastManager, RemoveToastNotification, AddToastNotification};